import { useGetPropertiesQuery as useGetPropertiesTokkoQuery } from '@apis/middlewareTokkoApi/properties'
import { useGetPropertiesQuery as useGetPropertiesMediacoreQuery } from '@apis/mediacore/properties'
import { useGetNewPropertiesQuery as useGetPropertiesMiddlewareTokkoQuery } from '@apis/mediacore/owner'
import {
  getParamsSearcher,
  makeFormDataV2ByFilters,
  makeParamsByFiltersMediacore,
  makeParamsGetByFilters,
} from '@helpers/helper.filters'
import { SearcherFilterData } from 'types'

type Props = {
  filters: any
  tokkoKey?: string
}

function useQuerySearcher({ filters, tokkoKey }: Props) {
  const params_get = getParamsSearcher(filters, tokkoKey ? false : true)

  const middlewarev2: boolean = process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() === 'true'
  const params_post = makeFormDataV2ByFilters(filters, [], [])
  const {
    data,
    data: properties,
    isLoading,
    isError,
    isFetching,
  } = tokkoKey //EDIT
    ? middlewarev2
      ? useGetPropertiesMiddlewareTokkoQuery({
          API_KEY: tokkoKey,
          params_get: params_get,
          params_post: params_post,
          coordinates: [],
          polygonCoordinates: [],
        })
      : useGetPropertiesTokkoQuery(
          {
            API_KEY: tokkoKey,
            params_get: params_get,
          },
          {
            skip: filters?.address === '',
          },
        )
    : useGetPropertiesMediacoreQuery(
        {
          CLIENT_ID: process.env.GATSBY_CLIENTID,
          params_get: params_get,
        },
        {
          skip: filters?.address === '',
        },
      )

  return {
    data,
    properties,
    isLoading,
    isError,
    isFetching,
  }
}

export default useQuerySearcher
